<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <g fill="none" fill-rule="evenodd">
        <path d="M1 1h20v20H1z"/>
        <circle cx="11" cy="11" r="11" fill="#CC1F1F"/>
        <g fill="#FFF">
            <path d="M10.118 6h2v8h-2zM10 15h2v2h-2z"/>
        </g>
    </g>
</svg>
